import { CYLINDO_ACCOUNT_ID } from 'commons/constants';

const CYLINDO_CONTENT_API = 'https://content.cylindo.com/api/v2';

export const probeLatestVersion = (productId, version) =>
  fetch(
    `${CYLINDO_CONTENT_API}/${CYLINDO_ACCOUNT_ID}/products/${productId}/configuration?version=${version +
      1}`,
    { method: 'HEAD' }
  ).then(res =>
    res.status === 200 ? probeLatestVersion(productId, version + 1) : version
  );
